import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import firebase from '../helpers/firebase';
import Loader from 'halogen/RingLoader'
import { Row } from 'react-bootstrap';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { connect } from 'react-redux';
import { TABLE_NAME, EMPLOYMENT, TIMEOFF } from '../helpers/constants';
import UserTable from './UserTable';

const db = firebase.database();

class User extends Component {
  constructor(props) {
    super(props);
    this.onFieldChange = this.onFieldChange.bind(this);
  }

  onFieldChange(task) {
    db.ref(TABLE_NAME.USERS).child(this.props.user.id).update(task);
  }

  render() {
    const {user, balance: { current }} = this.props;
    return (
      <tr>
        <td>
          <Link to={`/admin/users/${user.id}`}>
            {user.name}
          </Link>
        </td>
        <td>{user.email}</td>
        <td>
          <DayPickerInput
            value={user.startDate || '2017-01-01'}
            onDayChange={(date) => this.onFieldChange({
              'startDate': date.format('YYYY-MM-DD')
            })}
            name="startDate"
            id="startDate"
            format="YYYY-MM-DD"
          />
        </td>
        {
          Object.keys(TIMEOFF).map(key => {
            let type = TIMEOFF[key].type;
            return <td>
              {(current && current[type].balance) || 0}
            </td>;
          })
        }
      </tr>
    )
  }
}

class AdminUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      users: [],
      balances: null,
    }

    const { user } = this.props;

    if (!(user.level && user.level === 'admin')) {
      window.location.href = '/dashboard';
      return true;
    }

    this.getUsers();

    this.getUsers = this.getUsers.bind(this);
  }

  getUsers() {
    db.ref(TABLE_NAME.USERS).once('value').then((snapshots) => {
      const users = [];

      snapshots.forEach((snapshot) => {
        const u = Object.assign({id: snapshot.key}, snapshot.val());
        users.push(u);
      })
      this.setState({
        users: users,
      });
      return db.ref(TABLE_NAME.BALANCES).once('value');
    }).then((snapshots) => {
      this.setState({
        balances: snapshots.val(),
      });
    });
  }

  render() {
    if (
      !this.props.user ||
      !this.props.user.id.length ||
      !this.state.users.length ||
      !this.state.balances
    ) {
      return (
        <Loader color="#26194b" size="120px" className="loader" />
      )
    }

    const fullTimeUsers = this.state.users.map((u) => {
      if (!u.employment || u.employment === EMPLOYMENT.FT.type) {
        return (<User user={u} balance={this.state.balances[u.id]} key={u.id} />);
      }
      return (<div></div>);
    });
    const otherUsers = this.state.users.map((u) => {
      if (u.employment && u.employment !== EMPLOYMENT.FT.type) {
        return (<User user={u} balance={this.state.balances[u.id]} key={u.id} />);
      }
      return (<div></div>);
    })

    return (
      <div className="AdminUser">
        <Row>
          { this.props.user.name ? (
            <h1>Welcome back, {this.props.user.name}!</h1>
          ) : (
            <h1>Welcome back!</h1>
          ) }
        </Row>
        <UserTable title={EMPLOYMENT.FT.fullForm} rows={fullTimeUsers}/>
        <UserTable title="Others" rows={otherUsers}/>
      </div>
    );

  }
}

const mapStateToProps = (state) => {
  const { user } = state.auth;
  return { user };
}

export default connect(mapStateToProps)(AdminUser);



// WEBPACK FOOTER //
// ./src/components/AdminUser.js